import moment from 'moment-timezone'

export type CalendarEvent = {
    start: string | Date
    end?: string | Date
    allDay?: boolean
}

export const formatEventDate = (event: CalendarEvent, timezone: string = 'local'): string => {
    if (event.allDay) {
        if (event.end) {
            const endDate = moment(event.end).subtract(1, 'day')
            return `${moment(event.start).tz(timezone).format('MMMM D, YYYY')} (All day) - ${endDate
                .tz(timezone)
                .format('MMMM D, YYYY')} (All day)`
        }
        return moment(event.start).tz(timezone).format('MMMM D, YYYY') + ' (All day)'
    }

    const startDate = moment(event.start).tz(timezone).format('MMMM D, YYYY')
    const startTime = moment(event.start).tz(timezone).format('h:mm A')

    if (event.end) {
        const endDate = moment(event.end).tz(timezone).format('MMMM D, YYYY')
        const endTime = moment(event.end).tz(timezone).format('h:mm A')
        return `${startDate} (${startTime}) - ${endDate} (${endTime})`
    }

    return `${startDate} (${startTime})`
}
